import React from 'react';
import { createRoot } from 'react-dom/client';

import 'normalize.css';
import './index.scss';

// App Component
import App from './app';

document.addEventListener('DOMContentLoaded', (): void => {
  const container = document.getElementById('root');
  const root = createRoot(container)

  root.render(<App />);
});